import { render } from "./AddItemDialog.vue?vue&type=template&id=55ebfc58"
import script from "./AddItemDialog.vue?vue&type=script&lang=js"
export * from "./AddItemDialog.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__